/*
 * chartRegistry.js
 * ---------------------------------------------------------------------------
 * Registo partilhado das instancias de grafico actualmente no ecra.
 *
 * Serve para o botao "Export all to PDF" viver no formulario (KPIsOverviewForm)
 * enquanto os graficos vivem noutro componente (KPIsOverviewCharts): cada
 * grafico regista-se aqui pela sua chave e o formulario le a lista na hora de
 * exportar. As instancias do Chart.js nao sao serializaveis, por isso NAO vao
 * para o Redux -- este registo em memoria e o sitio certo para elas.
 * ---------------------------------------------------------------------------
 */

// Map preserva a ordem de insercao -> a ordem dos graficos no ecra.
const registry = new Map();

/* Regista (getter != null) ou remove (getter == null) um grafico. */
export const registerChart = (key, getter) => {
	if (getter) {
		registry.set(key, getter);
	} else {
		registry.delete(key);
	}
};

/*
 * Devolve as entradas de exportacao de todos os graficos registados, na ordem
 * do ecra. Cada getter devolve { title, subtitle, period, legend, canvas }.
 */
export const getChartEntries = () => {
	const entries = [];
	registry.forEach((getter) => {
		const entry = getter && getter();
		if (entry && entry.canvas) {
			entries.push(entry);
		}
	});
	return entries;
};